import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import lscache from 'lscache';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import queryClient from './api/query-client';
import { AppProvider } from './context/app';
import reportWebVitals from './reportWebVitals';
import 'src/i18n';
import { applyTheme } from 'src/utils/theme';

import './index.scss';

lscache.flushExpired();
applyTheme();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <App />
      </AppProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
